import { render, staticRenderFns } from "./DashEmployeeCard.vue?vue&type=template&id=26aca365&"
import script from "./DashEmployeeCard.vue?vue&type=script&lang=js&"
export * from "./DashEmployeeCard.vue?vue&type=script&lang=js&"
import style0 from "./DashEmployeeCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports